var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:[
    _vm.$style.button,
    ( _obj = {}, _obj[_vm.$style.loading] = _vm.isLoading, _obj[_vm.$style.iconBefore] = !!_vm.$slots.iconBefore, _obj[_vm.$style.iconAfter] = !!_vm.$slots.iconAfter, _obj ) ]},_vm.$listeners),[(_vm.$slots.iconBefore)?_vm._t("iconBefore"):_vm._e(),_c('span',{class:_vm.textClasses},[_vm._t("default")],2),(_vm.$slots.iconAfter)?_vm._t("iconAfter"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }